import React from 'react';
import { Stack } from '@mui/material';
import { LineItemProduct } from './LineItemProduct';
import { Product } from 'modules/contract/types';

interface ChooseLineItemStepCompletedProps {
  product: Product
}

export const ChooseLineItemStepCompleted: React.FC<ChooseLineItemStepCompletedProps> = ({ product }) => {
  return (
    <Stack gap={3} marginLeft={7} marginTop={2}>
      <LineItemProduct product={product} />
    </Stack>
  );
};